import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import history from '../../../history';

const TableComplaintsAndClaimsActions = ({ data, Callback }) => {

    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {
    }, []);

    const closeModalDelete = () => {
        setDeleteModal(false);
    }

    const goToCompplaintOrClaim = () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/form-complaints-claims',
            state: { complaints_claim: data.data.original }
        });
    }

    const deleteComplaintOrClaim = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'quejas-reclamos/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_queja: data.data.original.id_queja })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error('Ha ocurrido un error eliminando la Queja');
            }
        }).then((data) => {
            setSuccessModal(true);
        }).catch(err => {
            setErrorModal(true);
            console.log(err);
        });
    }

    const onOkModal = () => {
        setSuccessModal(false);
        Callback();
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Editar">
                <IconButton style={{ fontSize: '15px' }} onClick={() => {
                    goToCompplaintOrClaim();
                }}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar Queja y/o Reclamo">
                <IconButton style={{ fontSize: '15px' }} onClick={() => {
                    setDeleteModal(true);
                }}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
        </td>

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar esta queja y/o reclamo?"
            modal={showDeleteModal}
            onOk={() => deleteComplaintOrClaim()}
            toggle={() => closeModalDelete()}
        />

        <AlertModal
            color="success"
            title="Queja y/o reclamo eliminado correctamente"
            modal={successModal}
            onOk={() => onOkModal()}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar la Queja y/o reclamo"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />

    </Fragment>)
}

export default TableComplaintsAndClaimsActions;